var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0013 8.99956C13.0013 9.55185 12.5536 9.99956 12.0013 9.99956C11.449 9.99956 11.0013 9.55185 11.0013 8.99956C11.0013 8.44728 11.449 7.99956 12.0013 7.99956C12.5536 7.99956 13.0013 8.44728 13.0013 8.99956Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 11.7496C12.4155 11.7496 12.7513 12.0853 12.7513 12.4996V17.4996C12.7513 17.9138 12.4155 18.2496 12.0013 18.2496C11.5871 18.2496 11.2513 17.9138 11.2513 17.4996V12.4996C11.2513 12.0853 11.5871 11.7496 12.0013 11.7496Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2716 3.9922C13.1797 2.39453 10.8229 2.39453 9.73089 3.99219L9.29897 4.62414C6.59293 8.58335 4.26797 12.79 2.35524 17.1876L2.26502 17.3951C1.59097 18.9448 2.60933 20.7045 4.28888 20.8923C9.41451 21.4651 14.588 21.4651 19.7136 20.8923C21.3932 20.7045 22.4116 18.9448 21.7375 17.3951L21.6473 17.1876C19.7346 12.79 17.4096 8.58336 14.7036 4.62414L14.2716 3.9922ZM10.9693 4.8386C11.4656 4.11239 12.5369 4.11239 13.0332 4.83861L13.4652 5.47055C16.1178 9.35157 18.3968 13.4751 20.2718 17.7859L20.362 17.9933C20.6334 18.6174 20.2233 19.326 19.547 19.4015C14.5321 19.962 9.47039 19.962 4.45549 19.4015C3.77919 19.326 3.36913 18.6174 3.64055 17.9933L3.73076 17.7859C5.60572 13.4751 7.88476 9.35157 10.5374 5.47055L10.9693 4.8386Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardErr);
export default __webpack_public_path__ + "static/media/card_err.da8b2c18cea69dd399a845d950c04287.svg";
export { ForwardRef as ReactComponent };